export function initBtbCarousel() {
  const carousel = document.querySelector(".js-btb-wrapper");
  if (!carousel) return;

  function sync() {
    if (window.innerWidth < 768) {
      if (!carousel.classList.contains("flickity-enabled")) {
        new Flickity(carousel, {
          cellAlign: "center",
          contain: false,
          pageDots: false,
          prevNextButtons: false,
          wrapAround: true,
          adaptiveHeight: true,
        });
      }
    } else if (carousel.classList.contains("flickity-enabled")) {
      const flkty = Flickity.data(carousel);
      if (flkty) flkty.destroy();
    }
  }

  sync();
  window.addEventListener("resize", sync);
}

initBtbCarousel();
